export const SYSTEM_ROLES = [
  'SuperAdmin',
  'BusinessAdmin',
  'Customer',
  'Registered',
  'Blocked',
  'RequestedAccess',
] as const

export const USER_ROLES = [
  ...SYSTEM_ROLES,
  'AkashUsers',
  'AkashUsersRequestedAccess',
  'ReadOnlyCPUCloud',
  'CrdCpuCloud',
] as const

export type UserRole = (typeof USER_ROLES)[number]

const SYSTEM_ROLE_SET = new Set<string>(SYSTEM_ROLES)

export function isSystemRole(roleName: string): boolean {
  return SYSTEM_ROLE_SET.has(roleName)
}
